import React from 'react';
import Button from '../../components/Button';

import shapeImg from '../../assets/img/newsletter/shape-6-1.png';

const Newsletter = () => {
  return (
    <div className="it-newsletter-3-area p-relative z-index theme-bg">
      <div className="it-newsletter-3-shape-1">
        <img src={shapeImg} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-6 col-lg-6 col-md-6">
            <div className="it-newsletter-3-left">
              <h5 className="it-newsletter-3-title mb-0">
                Subscribe & Get <i>10% OFF</i> for first order
              </h5>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6">
            <div className="it-newsletter-3-right">
              <div className="it-newsletter-3-input-box p-relative">
                <form action="#">
                  <input type="email" placeholder="Your email address" />
                  <button className="it-btn-theme theme-bg">
                    <Button btnText="Subscribe" />
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
